import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon_11.png'


const _withScopeId = n => (_pushScopeId("data-v-2fad94db"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "wh-14",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-8 fz-14 lh-36" }, "模板下载", -1))

import { ref, getCurrentInstance } from 'vue';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'TemplateDownloadBtn',
  props: {
		data: {
			type: Object,
			default: function () {
				return {}
			}
		},
	},
  setup(__props) {

	const props = __props;

	const { proxy } = getCurrentInstance() as any;
	const loading = ref(false);

	const TemplateDownLoad = () => {
		if (!props.data.api) {
			proxy.$message.error("api链接不能为空");
			return false;
		}
		if (loading.value) {
			return false;
		}
		loading.value = true;
		proxy.$api.tokenRequest({
			url: props.data.api,
			isLoading: '加载中...',
			success: (res : any) => {
				loading.value = false;
				let a : any = document.createElement('a');
				a.href = res.data;
				a.setAttribute('download', `${props.data.name}模板`);
				a.click();
				a = null;
			},
			fail: () => {
				loading.value = false;
			},
		});
	};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_button, {
      class: "download-btn",
      plain: "",
      type: "primary",
      onClick: TemplateDownLoad
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2
      ]),
      _: 1
    })
  ]))
}
}

})